export const COLORS: Record<string, any> = {
    "Red": {
        "color": "#f00",
        "textColor": "white"
    },
    "Green": {
        "color": "#0f0",
        "textColor": "black"
    },
    "Blue": {
        "color": "#00f",
        "textColor": "white"
    },
    "Yellow": {
        "color": "#ff0",
        "textColor": "black"
    },
    "White": {
        "color": "white",
        "textColor": "black"
    },
    "Black": {
        "color": "black",
        "textColor": "white"
    },
    "Orange": {
        "color": "#f80",
        "textColor": "black"
    },
    "Purple": {
        "color": "#B0B",
        "textColor": "white"
    },
    "Pink": {
        "color": "#f8f",
        "textColor": "black"
    },
}
